﻿window.cObjetStructuresMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetTableUpdateLib = function () { return ["champ_table_nomstructure"] }

    var _lstChampTableData = null
    this.mGetLstChampTableData = function (funcOkAsync) {
        if (_lstChampTableData == null) {
            if (typeof objet.data == 'undefined' || objet.id == null) {
                //on est sur un element non sauvegardé
                _lstChampTableData = []
                if (typeof funcOkAsync != 'undefined') funcOkAsync(_lstChampTableData)
            } else {
                Me.objet.bddRef.mAjaxCall({
                    command: "getchamptabledata",
                    id_table: objet.mGetTable().id_table,
                    id_historique_sup: objet.id_historique_sup,
                    id: objet.id,
                    async: (typeof funcOkAsync != 'undefined')
                }, function (data) {
                    _lstChampTableData = ((typeof data.lstdata == 'undefined') ? [] : data.lstdata)
                    if (typeof funcOkAsync != 'undefined') funcOkAsync(_lstChampTableData)
                })
            }
        } else {
            if (typeof funcOkAsync != 'undefined') funcOkAsync(_lstChampTableData)
        }
        return _lstChampTableData
    }
    this.mSetLstChampTableData = function (lstChampTableData) {
        _lstChampTableData = lstChampTableData
    }

    this.mAddChampTableNom = function (nom) {
        _lstChampTableData = []
        var dataString = Me.objet.bddRef.getObjet("champ_table_string").mGetNewData()
        dataString.valeur = nom
        dataString.id_champ_table = parametre.champ.id_champ_table_nomstructure
        _lstChampTableData.push(dataString)
    }

    this.mGetLibBase = function () { return "Structure"; }
    this.mGetAttributBase = function () { return "la " }
    this.mGetNewLib = function () { return "Nouvelle structure"; }
    this.mGetLib1 = function (option) {
        if (typeof option == 'undefined') option = {}
        if (typeof option.dataTemplate != 'undefined') {
            return mGetLib1(option.dataTemplate)
        } else {
            if (typeof objet.data == 'undefined') {
                if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack("") }
                else { return "" }
            } else {
                var txt = ""
                if (Me.objet.cle() == null) {
                    if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
                    else { return txt }
                } else {
                    Me.objet.bddRef.mAjaxCall({
                        command: "getlstdatavirtualgrid",
                        data: [{ id_table: Me.objet.mGetTable().id_table, id: Me.objet.cle() }],
                        async: (typeof option.callBack != 'undefined')
                    }, function (data) {
                        var dataTemplate = ((typeof data.lstdatatemplate == "undefined") ? null : data.lstdatatemplate[0])
                        txt = ((dataTemplate == null) ? "" : mGetLib1(dataTemplate))
                    })
                    return txt
                }
            }
        }

        function mGetLib1(dataTemplate) {
            var txt = ""
            if (dataTemplate.nom_str != null) { txt = dataTemplate.nom_str }
            if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
            else { return txt }
        }
        //var champTableNom = this.mGetLstChampTableData().filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_nomstructure })[0]
        //if (typeof champTableNom == 'undefined') { return "" }
        //else {
        //    var txt = "";
        //    if (champTableNom.valeur != null && champTableNom.valeur.length > 0) txt += champTableNom.valeur;
        //    return txt;
        //}
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetNomFromTemplate = function (dataTemplate) {
        return this.mGetLibNomPrenomFromDataTemplate(dataTemplate)
    }
    this.mGetLibNomPrenomFromDataTemplate = function (dataTemplate) {
        var txt = ""
        if (dataTemplate.nom_str == null || dataTemplate.nom_str.length == 0) { txt = "" }
        else {
            var txt = dataTemplate.nom_str;
        }
        return ((txt.length == 0) ? "(Pas de nom)" : txt)
    }

    this.mGetNom = function () {
        return this.mGetLib1()
        //var champTableNom = this.mGetLstChampTableData().filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_nomstructure })[0]
        //if (typeof champTableNom == 'undefined') { return "" }
        //else {
        //    var txt = "";
        //    if (champTableNom.valeur != null && champTableNom.valeur.length > 0) txt += champTableNom.valeur;
        //    return txt;
        //}
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        if (typeof objet.data == 'undefined') {
            //on est sur une nouvelle structure
        } else {
            txt = this.mGetLib1()
            //var champTableNom = this.mGetLstChampTableData().filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_nomstructure })[0]
            //if (typeof champTableNom == 'undefined') { txt = "" }
            //else {
            //    var txt = "";
            //    if (champTableNom.valeur != null && champTableNom.valeur.length > 0) {
            //        if (champTableNom.valeur.length >= 2) { txt += champTableNom.valeur.substring(0, 2); }
            //        else { txt += champTableNom.valeur.substring(0, 1); }
            //    }
            //    return txt;
            //}
        }
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        var $Icone = null
        if (typeof objet.data == 'undefined') { $Icone = $("<i class='fas fa-home' style='position:relative'></i>"); }
        else {
            $Icone = $("<i class='fas fa-home' style='position:relative'></i>");
        }
        var nbStrCon = null
        var idCptCli = null
        if (typeof dataTemplate != 'undefined') {
            nbStrCon = dataTemplate.nb_con
            if (typeof dataTemplate.id_compte_client != 'undefined' && dataTemplate.id_compte_client != null) {
                idCptCli = dataTemplate.id_compte_client
                //$("<i class='fas fa-burst' style='position:absolute;top:-5px;right:-5px;color:red;font-size:65%;'></i>").appendTo($Icone)
            }
        } else if (typeof objet.data != 'undefined') {
            nbStrCon = objet.bddRef.getObjet("structures_contact").objetMetier.mGetLstDataStrCon(objet.data.id_structures, null).length
            //nbStrCon = objet.bddRef.mGetArray("structures_contact").filter(function (o) { return o.id_structures == objet.data.id_structures }).length
            if (objet.bddRef.nom_base.endsWith("_aagest") && typeof objet.data.id_compte_client != 'undefined' && objet.data.id_compte_client != null) {
                idCptCli = objet.data.id_compte_client
                //$("<i class='fas fa-burst' style='position:absolute;top:-5px;right:-5px;color:red;font-size:65%;'></i>").appendTo($Icone)
            }
        } 
        if (idCptCli != null) $("<i class='fas fa-burst' style='position:absolute;top:-5px;right:-5px;color:red;font-size:65%;'></i>").appendTo($Icone)
        if (nbStrCon != null && nbStrCon != 0) {
            $("<div style='position:absolute;bottom:-3px;left:-3px;padding:3px 5px;font-size:30%;font-style:normal;border-radius:50%;background-color:" + theme.backgroundcolorAccent + ";' title='" + nbStrCon + " contacts'>" + ((nbStrCon < 10) ? nbStrCon : "∞") + "</div>").appendTo($Icone)
        }
        $Icone.attr("title", "Structure")
        return $Icone
    }

    this.mGetLstChampTable = function () {
        return Me.objet.bddRef.mGetArray("champ_table")
        //var lstChampOrder = []
        //Me.objet.bddRef.mGetArray("champ_table_config").filter(function (o) {
        //    return o.id_table == objet.mGetTable().id_table;
        //}).sort(function (o1, o2) { return parseInt(o1.tri) - parseInt(o2.tri) }).forEach(function (champTableConfig) {
        //    var champTable = Me.objet.bddRef.mGetArray("champ_table").filter(function (o) { return o.id_champ_table == champTableConfig.id_champ_table })[0]
        //    if (champTable.id_champ_table != parametre.champ.id_champ_table_nomprenom) lstChampOrder.push(champTable)
        //})
        //return lstChampOrder
        ////return Me.objet.bddRef.mGetArray("champ_table").filter(function (o) { return o.id_table == objet.mGetTable().id_table; }).sort(function (o1, o2) { return parseInt(o1.tri) - parseInt(o2.tri) })
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
    }
    this.mGetDataItemTemplate = function (funcOk) {
        this.mGetLstChampTableData(function (lstChampTableData) {
            var chData = new cTableChampData(Me.objet.bddRef, lstChampTableData)
            var adr = chData.mGetAdressePostaleDefaut()
            if (adr) {
                var obj = Me.objet.bddRef.getObjet(adr)
                adr = obj.objetMetier.mGetLibelleCourt()
            } else { adr = "" }
            var tel = ((objet.data.tel_sms == null) ? "" : objet.data.tel_sms)
            if (tel) {
                var obj = Me.objet.bddRef.getObjet(tel)
                tel = obj.objetMetier.mGetValueMiseEnForme()
            } else { tel = "" }
            var mobile = chData.mGetMobileDefaut()
            if (mobile) {
                var obj = Me.objet.bddRef.getObjet(mobile)
                mobile = obj.objetMetier.mGetValueMiseEnForme()
            } else { mobile = "" }
            var email = chData.mGetAdresseEmailDefaut()
            if (email) { email = email.valeur }
            else { email = "" }
            var site = chData.mGetSiteDefaut()
            if (site) { site = site.valeur }
            else { site = "" }
            funcOk({
                adr: adr,
                tel: tel,
                mobile: mobile,
                email: email,
                site: site
            })
        })
    }

    this.hasScrollPopup = function () { return false }
    //this.contentTemplateSaisie = function (contentElement, option) {
    //    contentElement.empty();
    //    if (typeof option == 'undefined') option = {}
    //    var opt = {
    //        bddCtrl: Me.objet.bddRef,
    //        showImage: false,
    //        id_table: objet.mGetTable().id_table,
    //        id: objet.data.id_structures,
    //        data: objet.data,
    //        objet: objet,
    //        onChange: option.onChange,
    //        onContentReady: option.onContentReady
    //    }
    //    if (option.hideNom) opt.lstIdChampTableHide = [parametre.champ.id_champ_table_nomstructure]
    //    if (option.showOnlyNom) opt.lstIdChampTableShow = [parametre.champ.id_champ_table_nomstructure]
    //    if (option.hideOrganiserFiche) opt.hideOrganiserFiche = option.hideOrganiserFiche
    //    var dxCtrlChampTable = $("<div style='padding:10px;'/>").appendTo(contentElement).dxCtrlChampTableData(opt).dxCtrlChampTableData("instance")
    //    return [dxCtrlChampTable]
    //}

    //this.mGetLstDataStructuresContact = function () {
    //    //return Me.objet.bddRef.lstIdStrCon.filter(function (o) { return o.idstr == objet.data.id_structures })
    //    return Me.objet.bddRef.mGetArray("structures_contact").filter(function (o) { return o.id_structures == objet.data.id_structures })
    //}

    this.mNbValue = function (withNom) {
        if (typeof withNom == 'undefined') withNom = false
        var nbValue = 0
        this.mGetLstChampTableData().forEach(function (champTableData) {
            if (withNom || (!withNom && champTableData.id_champ_table != parametre.champ.id_champ_table_nomstructure)) {
                if (Me.objet.bddRef.getObjet(champTableData).objetMetier.hasValue()) nbValue += 1
            }
            //if (!Me.objet.bddRef.getObjet(champTableData).objetMetier.hasValue() && (!withoutNom || champTableData.id_champ_table != parametre.champ.id_champ_table_nomstructure)) {
            //    var typeChamp = new cTypeChamp(champTableData.id_champ_table)
            //    nbValue += ((typeChamp.objet().hasValue()) ? 1 : 0)
            //}
        })
        return nbValue
    }

    this.mGetWidthPopup = function () { return 750 }
    this.isPopupFullScreen = true
    //this.mShowPopup = function (option) {
    //    if (typeof option == 'undefined') option = {}
    //    if (typeof option.fullScreen == 'undefined') option.fullScreen = true
    //    page.mAddPopup(objet.data, option)
    //}
    this.contentTemplatePopup = function (contentElement, option) {
        $("<div/>").appendTo(contentElement).dxCtrlPopupFicheContactEtActivite({
            bddCtrl: Me.objet.bddRef,
            id_table_destinataire: objet.mGetTable().id_table,
            id_destinataire: objet.cle(),
            onSelectionChanged: option.onSelectionChanged,
            optionPopup: option,
            getUrl: function (funcOk) {
                objet.mGetDataTemplate([], function (dataTemplate) {
                    if (dataTemplate.site_web != null && dataTemplate.site_web.length > 0) { funcOk(dataTemplate.site_web) }
                    else { funcOk(objet.mGetLib1()) }
                })
            }
        })
    }

    this.mAddEventChangeLib = function (container, func) {
        Me.objet.bddRef.mAddFunctionOnModifiedItemData(["champ_table_string"], container,
            function (action, itemData) {
                if (typeof itemData != 'undefined' && itemData.id_table == Me.objet.bddRef.table.mGetIdTable("structures") && itemData.id == objet.cle()) {
                    if (itemData.id_champ_table == parametre.champ.id_champ_table_nomstructure) {
                        func()
                    }
                }
            })
    }

    //return le champValeur unitaire à partir d'un champTable
    this.mGetChampTableDataUnitaire = function (chpTableData) {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        return champTableData.mGetChampTableData(chpTableData)
    }
    //return la liste des champValeur à partir d'un champTable
    this.mGetLstChampTableDataUnitaire = function (chpTableData) {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        return champTableData.mGetLstChampTableData(chpTableData)
    }

    //return l'adresse postale au niveau du str
    this.mGetChampAdressePostaleDefautDirect = function () {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        var dataAdr = champTableData.mGetAdressePostaleDefaut()
        if (typeof dataAdr != 'undefined' && dataAdr != null) { return dataAdr }
        else { return null }
    }

    this.mGetChampAdressePostaleDefaut = function () {
        return this.mGetChampAdressePostaleDefautDirect()
    }

    this.mGetChampSiteDefaut = function () {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        var dataSiteWeb = champTableData.mGetSiteDefaut()
        if (typeof dataSiteWeb != 'undefined' && dataSiteWeb != null) { return dataSiteWeb }
        else { return null }
    }

    //return l'adresse email au niveau du str
    this.mGetChampAdresseEmailDefautDirect = function () {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        var dataAdrMail = champTableData.mGetAdresseEmailDefaut()
        if (typeof dataAdrMail != 'undefined' && dataAdrMail != null) { return dataAdrMail }
        else { return null }
    }

    this.mGetChampAdresseEmailDefaut = function () {
        return this.mGetChampAdresseEmailDefautDirect()
    }

    this.mGetAdresseEmailDefaut = function () {
        var champTableData = this.mGetChampAdresseEmailDefaut()
        if (champTableData != null) { return champTableData.valeur }
        else { return "" }
    }

    this.mAddAdresseEmailSiVide = function (adrEmail) {
        if (this.mGetAdresseEmailDefaut().length == 0) {
            //on a pas de mail
            var champTableEmail = Me.objet.bddRef.mGetArray("champ_table").filter(function (o) { return o.id_table == objet.mGetTable().id_table; }).filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_email })[0]
            var typeChamp = new cTypeChamp(champTableEmail.id_type_champ, Me.objet.bddRef)
            champDataEmail = typeChamp.mGetNewData(champTableEmail, objet.mGetTable().id_table, objet.cle())
            champDataEmail.valeur = adrEmail

            var tableChampDataEmail = new cTableChampData(Me.objet.bddRef)
            tableChampDataEmail.mSaveChampTableData("id_champ_table_email", champDataEmail, objet,
                function (obj) { obj.mSave() },
                null)
        }
    }

    //return le tel au niveau du str
    this.mGetChampTelDefautDirect = function () {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        var dataTelephone = champTableData.mGetTelephoneDefaut()
        if (typeof dataTelephone != 'undefined' && dataTelephone != null) { return dataTelephone }
        else { return null }
    }

    this.mGetChampTelDefaut = function () {
        return this.mGetChampTelDefautDirect()
    }

    this.mGetTelephoneDefaut = function () {
        var dataTelephone = this.mGetChampTelDefaut()
        if (typeof dataTelephone != 'undefined' && dataTelephone != null) { return Me.objet.bddRef.getObjet(dataTelephone).objetMetier.mGetValueMiseEnForme() }
        else { return "" }
    }

    //return le mobile au niveau du str
    this.mGetChampMobileDefautDirect = function () {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        var dataTelephone = champTableData.mGetMobileDefaut()
        if (typeof dataTelephone != 'undefined' && dataTelephone != null) { return dataTelephone }
        else { return null }
    }

    this.mGetChampMobileDefaut = function () {
        return this.mGetChampMobileDefautDirect()
    }

    this.mGetMobileDefaut = function () {
        var dataTelephone = this.mGetChampMobileDefaut()
        if (typeof dataTelephone != 'undefined' && dataTelephone != null) { return Me.objet.bddRef.getObjet(dataTelephone).objetMetier.mGetValueMiseEnForme() }
        else { return "" }
    }

    this.mShowNewStructures = function () {
        page.mAddPopup(Me.objet.mGetNewData(), {
            fullScreen: true,
            nomTable: "structures",
            funcCreate: function (funcOk) {
                var obj = Me.objet.bddRef.getObjet(Me.objet.bddRef.getObjet("structures").mGetNewData())
                obj.data.temporaire = 1
                obj.mSave(function () {
                    funcOk(obj.data)
                })
            }
        })
        //var obj = Me.objet.bddRef.getObjet(Me.objet.bddRef.getObjet("structures").mGetNewData())
        //obj.data.temporaire = 1
        //obj.mSave(function () {
        //    obj.mShowPopup();
        //})
    }

    this.mShowGridAndSelectStructures = function (option, funcOk) {
        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
            position: {
                my: "right top",
                at: "right top",
                of: "body"
            },
            width: 650,
            height: "100%",
            showTitle: true,
            showMaximize: true,
            title: ((typeof option.title == 'undefined') ? "Sélectionnez une structure" : option.title),
            contentTemplate: function (contentElement) {
                contentElement.css("padding-top", "0")

                var filterClass = new cFilterGeneral(option.bddCtrl,'strcon')
                var conditionsBase = {
                    ope_logique: "ET",
                    items: []
                }
                conditionsBase.items.push({
                    champ: filterClass.mGetChamp("id_table"),
                    operateur: "parmi",
                    isOpeNot: false,
                    value: [Me.objet.bddRef.table.mGetItemFromNom("structures_contact").id_table, Me.objet.bddRef.table.mGetItemFromNom("structures").id_table]
                })
                $("<div/>").appendTo(contentElement).dxCtrlGridStrCon({
                    bddCtrl: Me.objet.bddRef,
                    context_grid: "gridstrconaddcontactexistant",
                    lstTypeGrille: ["Lignes"],
                    //lstLstConditionBase: [[{ nom_champ: "id_table_element", ope: "parmi", valeur: [{ value: Me.objet.bddRef.table.mGetItemFromNom("structures_contact").id_table }, { value: Me.objet.bddRef.table.mGetItemFromNom("structures").id_table }] }]],
                    //conditionsBase: conditionsBase,
                    dataGridFiltreBase: {
                        montrer_str: 1,
                        montrer_strcon: 1,
                        montrer_con: 1,
                        montrer_cptcli: 1,
                        montrer_cptcliuti:1,
                        datafiltre: { id_filtrestrcon: null, type_filtre: "avance", json_lst_condition: JSON.stringify(conditionsBase) }
                    },
                    onClickDataGrid: function (container, dataGrid, dataTemplate) {
                        var table = Me.objet.bddRef.table.mGetItem(dataGrid.id_table)
                        var obj = Me.objet.bddRef.getObjet(table.nom, dataGrid.id)
                        var data = null
                        if (obj.mGetTable().nom == "structures_contact") {
                            data = obj.objetMetier.mGetDataStructures()
                        } else { data = obj.data }
                        popup.hide()
                        funcOk(data)
                    },
                    onEndClickDataGrid: function (dataGrid) { popup.hide(); },
                    allowCheck: false,
                    allowCarto: false,
                    allowFilter: true,
                    allowToolbar: true,
                    allowGroup: false,
                    showBtNew: false,
                    showColumnHeaders: false
                })
            }
        }).dxCtrlPopupBase("instance")
        popup.show();
        //popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
        //    position: {
        //        my: "right top",
        //        at: "right top",
        //        of: "body"
        //    },
        //    width: 650,
        //    height: "100%",
        //    showTitle: true,
        //    showMaximize: true,
        //    title: ((typeof option.title == 'undefined') ? "Sélectionnez une structure" : option.title),
        //    contentTemplate: function (contentElement) {
        //        Me.objet.bddRef.getObjet("structures_contact").contentTemplateGrid(contentElement, {
        //            filter_elements: ["structures", "structures_contact"],
        //            context_grid: "select_structures",
        //            allowCheck: false,
        //            showNewBt: false,
        //            showPlusBt: false,
        //            onClickItem: function (data) {
        //                if (Me.objet.bddRef.getObjet(data).mGetTable().nom == "structures_contact") {
        //                    data = Me.objet.bddRef.getObjet(data).objetMetier.mGetDataStructures()
        //                }
        //                popup.hide()
        //                funcOk(data)
        //            }
        //        });
        //    }
        //}).dxCtrlPopupBase("instance")
        //popup.show();
    }

    this.mAddTelMobileSiVide = function (dataTel) {
        if (this.mGetMobileDefaut().length == 0 && dataTel != null && dataTel.tel_number.length > 0) {
            //on a pas de mobile
            var champTableMobile = Me.objet.bddRef.mGetArray("champ_table").filter(function (o) { return o.id_table == objet.mGetTable().id_table; }).filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_mobile })[0]
            var typeChamp = new cTypeChamp(champTableMobile.id_type_champ, Me.objet.bddRef)
            champDataMobile = typeChamp.mGetNewData(champTableMobile, objet.mGetTable().id_table, objet.cle())

            champDataMobile.tel_code_pays = dataTel.tel_code_pays
            champDataMobile.tel_number = dataTel.tel_number
            champDataMobile.tel_complet = dataTel.tel_complet
            champDataMobile.telb_sms = dataTel.tel_sms
            champDataMobile.tel_error = dataTel.tel_error
            champDataMobile.tel_num_type = dataTel.tel_num_type

            var tableChampData = new cTableChampData(Me.objet.bddRef)
            tableChampData.mSaveChampTableData("id_champ_table_mobile", champDataMobile, objet,
                function (obj) { obj.mSave() },
                null)
        }
    }

    this.mAddORMajValueString = function (idChampTable, valeur, funcFin) {
        var champTableData = this.mGetLstChampTableData().filter(function (chpTableData) { return chpTableData.id_champ_table == idChampTable })[0]
        if (typeof champTableData == 'undefined') {
            var champTableConfigString = Me.objet.bddRef.mGetArray("champ_table_config").filter(function (o) { return o.id_table == objet.mGetTable().id_table; }).filter(function (o) { return o.id_champ_table == idChampTable })[0]
            champTableString = Me.objet.bddRef.mGetArray("champ_table").filter(function (o) { return o.id_champ_table == champTableConfigString.id_champ_table; })[0]
            var typeChamp = new cTypeChamp(champTableString.id_type_champ, Me.objet.bddRef)
            champTableData = typeChamp.mGetNewData(champTableString, objet.mGetTable().id_table, objet.cle())
        }
        champTableData.valeur = valeur

        var tableChampData = new cTableChampData(Me.objet.bddRef)
        tableChampData.mSaveChampTableData("id_champ_table_string", champTableData, objet,
            function (obj) {
                obj.mSave(function () {
                    if (typeof funcFin != 'undefined') funcFin()
                })
            },
            null)
    }

    this.mCreateStructure = function (value, funcOk) {
        //value = idTitre,nom,prenom,adresseEmail,adressePostal,telFixe,telMobile
        var dataStructures = Me.objet.bddRef.getObjet("structures").mGetNewData()

        var lstChampTableData = []
        var lstChampTable = Me.objet.bddRef.mGetArray("champ_table")//.filter(function (chp) {
        //    return Me.objet.bddRef.mGetArray("champ_table_config").filter(function (chpConf) {
        //        return chp.id_champ_table == chpConf.id_champ_table && chpConf.id_table == objet.mGetTable().id_table;
        //    }).length > 0
        //})

        if (typeof value.nom != 'undefined' && value.nom != null) {
            //nom
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_nomstructure })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableData = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableData.nom_table_champ_table = "champ_table_nomstructure"
            champTableData.valeur = value.nom
            lstChampTableData.push(champTableData)
        }
        if (typeof value.adresse_email != 'undefined' && value.adresse_email != null) {
            //adresse email
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_email })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableData = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableData.nom_table_champ_table = "champ_table_email"
            champTableData.valeur = value.adresse_email
            lstChampTableData.push(champTableData)
        }
        if (typeof value.adresse_postale != 'undefined' && value.adresse_postale != null) {
            //adresse postale
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_adr })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableData = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableData.nom_table_champ_table = "champ_table_adresse"
            champTableData.ad1 = value.adresse_postale.ad1
            champTableData.ad2 = value.adresse_postale.ad2
            champTableData.ad3 = value.adresse_postale.ad3
            champTableData.cp = value.adresse_postale.cp
            champTableData.ville = value.adresse_postale.ville
            champTableData.cedex = value.adresse_postale.cedex
            champTableData.dpt = value.adresse_postale.dpt
            champTableData.region = value.adresse_postale.region
            champTableData.pays = value.adresse_postale.pays
            champTableData.geo_latitude = value.adresse_postale.geo_latitude
            champTableData.geo_longitude = value.adresse_postale.geo_longitude
            champTableData.code_pays = value.adresse_postale.code_pays
            champTableData.normalise = value.adresse_postale.normalise
            lstChampTableData.push(champTableData)
        }
        if (typeof value.tel_fixe != 'undefined' && value.tel_fixe != null) {
            //téléphone fixe
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_tel })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableData = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableData.nom_table_champ_table = "champ_table_tel"
            champTableData.tel_code_pays = value.tel_fixe.code_pays
            champTableData.tel_number = value.tel_fixe.tel_number
            champTableData.tel_complet = value.tel_fixe.tel_complet
            champTableData.tel_sms = value.tel_fixe.tel_sms
            champTableData.tel_error = value.tel_fixe.tel_error
            champTableData.tel_num_type = value.tel_fixe.tel_num_type
            lstChampTableData.push(champTableData)
        }
        if (typeof value.tel_mobile != 'undefined' && value.tel_mobile != null) {
            //téléphone mobile
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_mobile })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableData = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableData.nom_table_champ_table = "champ_table_tel"
            champTableData.tel_code_pays = value.tel_mobile.code_pays
            champTableData.tel_number = value.tel_mobile.tel_number
            champTableData.tel_complet = value.tel_mobile.tel_complet
            champTableData.tel_sms = value.tel_mobile.tel_sms
            champTableData.tel_error = value.tel_mobile.tel_error
            champTableData.tel_num_type = value.tel_mobile.tel_num_type
            lstChampTableData.push(champTableData)
        }
        if (typeof value.site_web != 'undefined' && value.site_web != null) {
            //téléphone mobile
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_siteweb })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableData = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableData.nom_table_champ_table = "champ_table_site"
            champTableData.valeur = value.site_web
            lstChampTableData.push(champTableData)
        }
        dataStructures.id_utilisateur = Me.objet.bddRef.utiCourant.id_utilisateur

        Me.objet.bddRef.mAjaxCall({ command: "create_structure_with_data", data: dataStructures, lst_champ_table_data: lstChampTableData }, function (data) {
            dataStructures.id_structures = data.id
            funcOk(dataStructures)
        })
    }

    this.mGetPopupPositionWidthHeight = function () {
        return {
            width: "700",
            maxWidth: "calc(100% - 60px)",
            height: "calc(100% - 90px)",
            maxHeight: "calc(100% - 50px)",
            position: {
                my: "right top",
                at: "right top",
                of: "body",
                offset: { x: -30, y: 65 }
            }
        }
    }

    this.mPrint = function () {
        jaugeDemarrage.mShow()
        objet.bddRef.mAjaxCall({
            command: "printstrcon",
            id_table:objet.mGetTable().id_table,
            id: objet.cle()
        }, function (data) {
            if (data.urlpdf) {
                if (data.urlpdf.startsWith("~")) data.urlpdf = data.urlpdf.substring(1)
                $("<div/>").dxCtrlPdfViewer({
                    urlPdf: data.urlpdf,
                    allowClose: true,
                    padding: "0px"
                })
                jaugeDemarrage.mHide()
            }
        })
    }

    this.mGetLstDataStr = function (idContact) {
        var lst = []
        var result = objet.bddRef.mAjaxCall({
            command: "getlststrfromcon",
            id_contact: idContact,
            async: false
        }, function (data) {
            if (!data.lstdatastructures) data.lstdatastructures = []
            lst = data.lstdatastructures
        })
        debugger;
        return lst
    }

}